import { render, staticRenderFns } from "./OrganizationProfileView.vue?vue&type=template&id=7b18218c&"
import script from "./OrganizationProfileView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationProfileView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b18218c')) {
      api.createRecord('7b18218c', component.options)
    } else {
      api.reload('7b18218c', component.options)
    }
    module.hot.accept("./OrganizationProfileView.vue?vue&type=template&id=7b18218c&", function () {
      api.rerender('7b18218c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/member/organization/profile/OrganizationProfileView.vue"
export default component.exports